import DtoHydrometryStationMeasure from './DtoHydrometryStationMeasure'

export default class DtoHydrometerAdditionalMeasures {
    constructor(object) {
        this.type = object.type
        this.measures = object.measures.map(m => new DtoHydrometryStationMeasure(m))
    }
}
